import React from "react";
import { Megaphone } from "lucide-react";

const FEEDBACK_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScRo3ud9MbzWkLPT2q8Qxx7wmZ3ixXwy-RvhzyWbwyOidfttg/viewform?usp=publish-editor";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="w-full text-white"
      style={{ backgroundColor: "#c80f3f" }}
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-2 flex items-center justify-center gap-2 text-center text-xs sm:text-sm">
        <Megaphone className="h-4 w-4 flex-shrink-0" strokeWidth={2} aria-hidden="true" />
        <span className="leading-snug">
          This Specification Tool is currently <strong>in development</strong>. We'd love your feedback —{" "}
          <a
            data-testid="announcement-feedback-link"
            href={FEEDBACK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline decoration-white/70 underline-offset-2 hover:decoration-white font-medium whitespace-nowrap"
          >
            share it here
          </a>
          .
        </span>
      </div>
    </div>
  );
}
